(() => {
  const mobileQuery = window.matchMedia('(max-width: 749px)');

  const initialiseDescription = (section) => {
    if (section.dataset.descriptionReady === 'true') return;

    const button = section.querySelector('[data-description-toggle]');
    const content = section.querySelector('[data-description-content]');
    const label = section.querySelector('[data-description-toggle-label]');
    if (!button || !content || !label) return;

    const setExpanded = (expanded) => {
      content.hidden = !expanded;
      button.setAttribute('aria-expanded', String(expanded));
      label.textContent = expanded ? button.dataset.collapseLabel : button.dataset.expandLabel;
      section.classList.toggle('is-expanded', expanded);
    };

    const syncViewport = () => {
      section.classList.toggle('is-mobile-collapsible', mobileQuery.matches);
      setExpanded(!mobileQuery.matches);
    };

    button.addEventListener('click', () => {
      setExpanded(button.getAttribute('aria-expanded') !== 'true');
    });

    if (mobileQuery.addEventListener) mobileQuery.addEventListener('change', syncViewport);
    else mobileQuery.addListener(syncViewport);

    section.dataset.descriptionReady = 'true';
    syncViewport();
  };

  const initialiseAll = () => document.querySelectorAll('[data-product-description]').forEach(initialiseDescription);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialiseAll, { once: true });
  else initialiseAll();

  document.addEventListener('shopify:section:load', initialiseAll);
})();
